import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import './badge.css';

/*
#tailwind
badge__bubble badge__bubble--icon badge__bubble--topRight badge__bubble--bottomRight badge__bubble--topLeft badge__bubble--bottomLeft
*/

function Badge({ children, count, overflowCount, showZero, placement, icon, ...other }) {
  const badgeContent = useMemo(() => {
    if (icon) {
      return icon;
    }
    if (count <= overflowCount) {
      return count;
    }
    return `${overflowCount}+`;
  }, [count, overflowCount, icon]);
  if (!showZero && count === 0 && !icon) return children;

  return (
    <span className="badge" {...other}>
      {children}
      <sub className={bem`badge__bubble--${{ [placement]: true, icon }}`}>{badgeContent}</sub>
    </span>
  );
}

Badge.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
  count: PropTypes.number,
  overflowCount: PropTypes.number,
  showZero: PropTypes.bool,
  placement: PropTypes.oneOf(['topRight', 'bottomRight', 'topLeft', 'bottomLeft']),
};

Badge.defaultProps = {
  icon: undefined,
  children: undefined,
  overflowCount: 9,
  count: 0,
  showZero: false,
  placement: 'topRight',
};

export default Badge;
